import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter" }

import { onMounted, ref } from 'vue';
import api from '@/api';
import { toast } from '@/lib/toast';


export default /*@__PURE__*/_defineComponent({
  __name: 'ApiEventFilter',
  props: {
  searchParams: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const apiList = ref([]);

onMounted(async () => {
  try {
    const { results } = await api.get('/api/vocab/event', { code: 'api/' });
    apiList.value = results;
  } catch (e) {
    toast.error(e.message);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t('Тип запроса')), 1 /* TEXT */),
    _createVNode(_component_v_select, {
      modelValue: __props.searchParams['event.event.id'],
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.searchParams['event.event.id']) = $event)),
      placeholder: _ctx.$t('Тип запроса'),
      items: apiList.value,
      "list-props": { class: 'api-events-page-select-filter-list' },
      "item-title": "name",
      "item-value": "id",
      "hide-details": "",
      variant: "solo",
      disabled: !apiList.value.length
    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "items", "disabled"])
  ]))
}
}

})